
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
const  Help = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
        <div className="ivo-text-box ivo-section text-center">
        <h2 className="ivo-heading">
            <span className="color_title">Help </span> Center
        </h2>
    </div>
    <section className=" help-page">
        <div className="container ivo-ovrflow-hidden">
            <div className="helping-box">
                <h1>General</h1>
                <div className="helping-content">
                    <h2>1. What is Ivoire?</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>IVOIRE IS WORLD'S MOST TRUSTED APP FOR COMODITY AND MARKET.</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="helping-content">
                    <h2>2. I need help! How can I contact Ivoire support?</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>The fastest way to get support is through our Help Center</p>
                            </div>
                        </li>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>If you are unable to find an answer to what you're looking for and still need help,
                                    please contact us via this link . We'd suggest you use the chat option there for a
                                    quick resolution.</p>
                            </div>
                        </li>
                    </ul>
                </div>


            </div>
            <div className="helping-box">
                <h1>Security</h1>
                <div className="helping-content">
                    <h2>1. Two-Factor Authentication (2FA) - Setup, Change & Recovery</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Two-Factor Authentication (2FA) provides an extra layer of security for your account
                                    by
                                    requiring a second step of verification when you log in or perform some specific
                                    actions.</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="helping-content">
                    <h2>2. Securing your Ivoire account - Tips & Best Practices</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Account Details</p>
                            </div>
                            <ul className="inner-ul-help">
                                <li>
                                    Never share account details like your registered Ivoire email ID, mobile number,
                                    bank details, Transaction number or amount publicly. Only share it with the support
                                    team if asked through official channels like the support.Ivoire.com
                                </li>
                            </ul>
                        </li>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Password</p>
                            </div>
                            <ul className="inner-ul-help">
                                <li>
                                    Always Set a strong password for your account
                                </li>
                                <li>
                                    Passwords must be at least 6 characters long and a maximum of 64 characters. We
                                    recommend using passwords longer than 10 characters.
                                </li>
                                <li>
                                    Include a combination of characters, numbers & symbols like $%^~ in your password
                                </li>
                                <li>
                                    Never use common words as passwords. For eg your name or birthdate or your pet's
                                    name
                                </li>
                                <li>
                                    Never use a password that you have used elsewhere. For eg - your email password,
                                    your Facebook password or even your password for another cryptocurrency exchange
                                </li>
                                <li>
                                    Never share your password with anyone else. WazirX will never call or email you
                                    asking for your password. Nobody needs your password to help you with a problem.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>


            </div>
            <div className="helping-box">
                <h1>Account Management</h1>
                <div className="helping-content">
                    <h2>1. What is the Ivoire Referral Program?</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>The Ivoire Referral Program is a great opportunity for you to earn 50% as reward of
                                    every trading fee paid by your friends on Ivoire It is our way of rewarding you for
                                    your efforts in helping bring more users to Ivoire and being a part of the crypto
                                    revolution in India! It is probably the most rewarding crypto referral program
                                    currently in India.</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="helping-content">
                    <h2>2. How does it work -</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Share your link - Share your referral link with your friends via email, social media,
                                    or any other way.</p>
                            </div>

                        </li>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Sign up - Your friends use your link to signup on Ivoire and make their first trade
                                    on Ivoire.</p>
                            </div>
                        </li>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Get rewarded - You earn 50% as reward of every trading fee paid by your friends. Even
                                    while you're asleep!</p>
                            </div>
                        </li>
                    </ul>
                </div>


            </div>

            <div className="helping-box">
                <h1>Signing Up </h1>
                <div className="helping-content">
                    <h2>1.Guide to Signing Up</h2>
                    <ul>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Step 1 - Email ID & Password</p>
                            </div>
                            <p className="helping-mini-heading">The first step in the sign-up process is to choose a login email address and set a
                                password.</p>
                            <ul className="inner-ul-help">
                                <li>
                                    <strong> Email</strong> - Enter your complete email address. This is the email
                                    address you will use to
                                    login and also receive any communication from us. You cannot change your login email
                                    address later.
                                </li>
                                <li>
                                    <strong>Password</strong> - Enter a strong password that you will remember.
                                    Passwords must be at
                                    least 6 characters long and a maximum of 64 characters. We recommend using passwords
                                    longer than 10 characters. Do not use passwords that you've already used on another
                                    website. Try and mix special characters like @#$%^&-* along with capitals and
                                    numerics in your password.
                                </li>
                            </ul>
                        </li>
                        <li className="helpin-li-upper">
                            <div className="heping-li">
                                <span><i className="fa-regular fa-circle-check"></i></span>
                                <p>Step 2 - Email Verification</p>
                            </div>
                          <p className="helping-mini-heading">Once you've entered your email, password and clicked on sign up, you will receive a
                            verification email at your email address.</p>
                            <ul className="inner-ul-help">
                                <li>
                                    Click on the Verify Email button in the email. You will be taken back to the Ivoire
                                    website where your verification will be confirmed! Note that the verification email
                                    is only valid for 15 minutes. If you do not verify in 15 minutes, login to your
                                    Ivoire account again and click on the Resend verification email button.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>



            </div>

        </div>
    </section>       
    </>

  );
}

export default Help;
